import { apiSlice } from "./http";

export type ShippingTestAction = "generate" | "dispatch" | "reset";

export interface ShippingTestBody {
  cycle: string;
}

export interface ShippingStateRow {
  id: number;
  type: string;
  generated_at: string | null;
  sent_at: string | null;
  blocked_at: string | null;
  attempts: number;
  deliveries: number;
  delivered: number;
  failed: number;
}

export interface CycleState {
  cycle: string;
  has_snapshot: boolean;
  shippings: ShippingStateRow[];
}

export interface ShippingTestJobResult {
  action: ShippingTestAction;
  cycle: string;
  detail: unknown;
  state: CycleState;
}

export interface ShippingTestJobStatus {
  job_id: string;
  state: string;
  progress: number;
  action: ShippingTestAction;
  cycle: string;
  requested_by: string;
  result: ShippingTestJobResult | null;
  failed_reason: string | null;
  finished_at: number | null;
}

const SHIPPING_TEST_URL = "/shipping/test";

export const shippingTestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateShippingCycle: builder.mutation<
      ShippingTestJobStatus,
      ShippingTestBody
    >({
      query: (body: ShippingTestBody) => ({
        url: `${SHIPPING_TEST_URL}/generate`,
        method: "POST",
        body,
      }),
    }),

    dispatchShippingCycle: builder.mutation<
      ShippingTestJobStatus,
      ShippingTestBody
    >({
      query: (body: ShippingTestBody) => ({
        url: `${SHIPPING_TEST_URL}/dispatch`,
        method: "POST",
        body,
      }),
    }),

    resetShippingCycle: builder.mutation<
      ShippingTestJobStatus,
      ShippingTestBody
    >({
      query: (body: ShippingTestBody) => ({
        url: `${SHIPPING_TEST_URL}/reset`,
        method: "POST",
        body,
      }),
    }),

    getShippingTestJob: builder.query<ShippingTestJobStatus, string>({
      query: (jobId: string) => `${SHIPPING_TEST_URL}/status/${jobId}`,
    }),
  }),
});

export const {
  useGenerateShippingCycleMutation,
  useDispatchShippingCycleMutation,
  useResetShippingCycleMutation,
  useGetShippingTestJobQuery,
} = shippingTestApi;
